import {
  AudioAttachmentDto,
  AudioServiceGetSourceRequestBody,
  AudioServiceGetTranscriptRequestBody,
  AudioServiceGetAudioMetricsRequestBody,
  GetSourceResponse,
  GetTranscriptResponse,
  CombineAudioResponse,
  GetAudioMetricsResponse,
  ProcessAudioAttachmentRequestBody,
  AudioServiceCombineAudioRequestBody,
  AudioServiceSplitAudioChannelsRequestBody,
  SplitAudioChannelsResponse,
} from '@scale/mm-shared';
import apiFetch from 'react-scale/lib/api-fetch';

export const processAudioAttachment = ({
  audioUrl,
  audioFormat,
  assignmentId,
  workerId,
  userGeneratedAudio,
  transcriptionService,
}: ProcessAudioAttachmentRequestBody): Promise<AudioAttachmentDto> =>
  apiFetch<AudioAttachmentDto, ProcessAudioAttachmentRequestBody>(
    null,
    `internal/multimodal-audio/process_audio_attachment`,
    {
      method: 'POST',
      body: {
        audioUrl,
        audioFormat,
        assignmentId,
        workerId,
        userGeneratedAudio,
        transcriptionService,
      },
    },
  );

export const transcribeAudio = ({
  audioUrl,
}: AudioServiceGetTranscriptRequestBody): Promise<GetTranscriptResponse> =>
  apiFetch<GetTranscriptResponse, AudioServiceGetTranscriptRequestBody>(
    null,
    `internal/multimodal-audio/transcribe_audio`,
    {
      method: 'POST',
      body: {
        audioUrl,
      },
    },
  );

export const getAudioMetrics = ({
  audioUrl,
}: AudioServiceGetAudioMetricsRequestBody): Promise<GetAudioMetricsResponse> =>
  apiFetch<GetAudioMetricsResponse, AudioServiceGetAudioMetricsRequestBody>(
    null,
    `internal/multimodal-audio/get_audio_metrics`,
    {
      method: 'POST',
      body: {
        audioUrl,
      },
    },
  );

export const getAudioSource = ({
  audioUrl,
}: AudioServiceGetSourceRequestBody): Promise<GetSourceResponse> =>
  apiFetch<GetSourceResponse, AudioServiceGetSourceRequestBody>(
    null,
    `internal/multimodal-audio/get_audio_source`,
    {
      method: 'POST',
      body: {
        audioUrl,
      },
    },
  );

export const combineAudio = ({
  audioUrl1,
  audioUrl2,
  assignmentId,
  workerId,
  projectId,
}: AudioServiceCombineAudioRequestBody): Promise<CombineAudioResponse> =>
  apiFetch<CombineAudioResponse, AudioServiceCombineAudioRequestBody>(
    null,
    `internal/multimodal-audio/combine_audio`,
    {
      method: 'POST',
      body: {
        audioUrl1,
        audioUrl2,
        assignmentId,
        workerId,
        projectId,
      },
    },
  );

export const splitAudioChannels = ({
  audioUrl,
  assignmentId,
  workerId,
  projectId,
}: AudioServiceSplitAudioChannelsRequestBody): Promise<SplitAudioChannelsResponse> =>
  apiFetch<SplitAudioChannelsResponse, AudioServiceSplitAudioChannelsRequestBody>(
    null,
    `internal/multimodal-audio/split_audio_channels`,
    {
      method: 'POST',
      body: {
        audioUrl,
        assignmentId,
        workerId,
        projectId,
      },
    },
  );
